var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"section-item mb-5"},[_c('h3',{staticClass:"is-size-5 has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',[_vm._v(_vm._s(_vm.description))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }